import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  defaultDocuments: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DefaultDocuments.defaultDocuments`,
    defaultMessage: 'Default Documents',
  },
  manageDocuments: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DefaultDocuments.manageDocuments`,
    defaultMessage:
      'Manage documents to send to applicants upon landing in this stage if no alternate documents are sent.',
  },
  // AXHE-4226: the sentence above describes the whole list, and since AXHE-4106
  // put offer letter templates INTO that list it is false for half of what the
  // list can hold. An offer letter is not sent on landing — it waits for a
  // recruiter to open Send Offer and enter the values (salary, start date,
  // bonus), and there is no data to send before that. The product owner attached
  // a template, watched an applicant land, saw nothing happen and read the
  // feature as broken; this copy is what told her to expect otherwise.
  //
  // A second message rather than an edit to the first: BaseStageSerializer omits
  // both offer letter keys entirely for an account without the
  // `offer-letter-templates` flag (base_stage_serializer.rb:144), so such a
  // stage cannot hold one and must keep reading exactly as it does today.
  //
  // AXHE-4400 renamed the noun in the second sentence. The KEY still says
  // `…WithOfferLetterTemplates`, which is deliberate: identifiers are out of
  // scope for that rename, and re-minting the id would orphan the string in
  // every catalog for no user-visible gain.
  manageDocumentsWithOfferLetterTemplates: {
    id: `app.containers.WorkflowEditor.components.StageDetail.DocumentSigningStage.Documents.DefaultDocuments.manageDocumentsWithOfferLetterTemplates`,
    defaultMessage:
      'Manage documents to send to applicants upon landing in this stage if no alternate documents are sent. Signature templates are sent by a recruiter, not upon landing.',
    description:
      'Variant of manageDocuments for a stage whose document list can also hold a signature template, which a recruiter sends rather than the stage sending it on landing',
  },
});
